export default function filterDate(date){
    console.log({date})
    const year = date.getUTCFullYear()
    let month = date.getMonth()+1
    month = parseInt(month)<10?`0${month}`:month;
    let day = date.getDate()
    day = parseInt(day)<10?`0${day}`:day;
    console.log(`${year}-${month}-${day}`)
    return `${year}/${month}/${day}`
}